import { BackendApiUrl } from "@/functions/BackendApiUrl";
import { useSwrFetcherWithAccessToken } from "@/functions/useSwrFetcherWithAccessToken";
import useSWR from "swr";
import { ApplicationHistoryList, ApplicationHistoryResponse } from "./interfaces/ApplicationHistoryInterface";
import { useFetchWithAccessToken } from "@/functions/useFetchWithAccessToken";

export function GetApplicationHistoryList(userId: string | undefined){
    const swrFetcher = useSwrFetcherWithAccessToken();
    const { data } = useSWR<ApplicationHistoryList>(
        userId
          ? `${BackendApiUrl.getApplicationHistoryList}?userId=${userId}`
          : null,
        swrFetcher
    );
    return data;
}


export function useAddApplicationHistory() {
    const { fetchPOST } = useFetchWithAccessToken();

    const addApplicationHistory = async (
        userId: string,
        vacancyId: string,
        businessUnitId: string | undefined
    ): Promise<ApplicationHistoryResponse> => {
        const payload = {
            userId,
            vacancyId,
            businessUnitId,
        };

        try {
            const response = await fetchPOST(BackendApiUrl.addApplicationHistory, payload);
            return response as ApplicationHistoryResponse;
        } catch (error) {
            throw new Error("Error adding application history: " + error);
        }
    };

    return { addApplicationHistory };
}